module.exports = __webpack_public_path__ + "img/icon_goods_on.68e509e9.svg";